<template>
  <div class="list-item with-icon pointer">
    <v-list-item-avatar :style="avatar.style" tile>
      <v-img :src="avatar.icon" max-width="35px" height="28" contain />
    </v-list-item-avatar>
    <v-list-item-content @click="viewTodo" data-test="todo-item-content">
      <div class="item-right" :class="{ 'flex-column': isMobile }">
        <div class="description">
          <div class="d-flex">
            <span class="font-weight-bold">{{ todo.action }}</span>
          </div>
          <div class="status-wrapper">
            <span
              v-html="todo.actionDetails"
              class="mr-1"
              :class="{ 'text-start': isMobile }"
            >
              {{ todo.actionDetails }}
            </span>
            <span>
              <span class="mx-1" v-if="!isMobile">|</span>
              <v-icon>mdi-timer-sand-empty</v-icon>
              {{ this.todo.deadline_date | baseDate }}
            </span>
          </div>
        </div>
        <span :class="{ 'text-start': isMobile, 'full-width': isMobile }">
          {{ dateForHuman }}
        </span>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
import { getAvatar, getPath } from "@/utils/dashboard";
import { dateForHuman } from "@/utils/time";

export default {
  props: {
    todo: {
      type: Object,
      required: true
    }
  },
  computed: {
    avatar() {
      return getAvatar(this.todo.icon);
    },
    dateForHuman() {
      return dateForHuman(this.todo.createdAt);
    }
  },
  methods: {
    viewTodo() {
      const path = getPath(this.todo);
      this.$router.push({ path });
    }
  }
};
</script>

<style lang="scss" scope>
.todos {
  .list-item.pointer {
    :hover {
      cursor: pointer;
    }
  }
}
</style>
